'use client';

import type {FormEvent} from 'react';
import clsx from 'clsx';
import {useRouter, useSearchParams} from 'next/navigation';

import type {EventsFilterSearchParams} from '../../app/(frontend)/kalender/page';

import {EventPageSelect} from './hero';

type Props = {
	filters?: EventsFilterSearchParams;
};

export const SortbyFilter = ({filters}: Props) => {
	const router = useRouter();
	const searchParams = useSearchParams();

	const handleFormChange = (e: FormEvent<HTMLFormElement>): void => {
		const newSearchParams = new URLSearchParams(searchParams);
		const formData = new FormData(e.currentTarget);

		const sorter = formData.get('sorter')?.toString() ?? '';

		if (sorter && sorter !== 'datoForst') {
			newSearchParams.set('sorter', sorter);
		} else {
			newSearchParams.delete('sorter');
		}

		router.replace(`?${newSearchParams.toString()}`, {scroll: false});
	};

	return (
		<form
			method="get"
			onChange={handleFormChange}
			className={clsx('mb-16', 'max-w-xs')}
		>
			<EventPageSelect
				darkLabel
				label="Sorter etter"
				id="sorter"
				name="sorter"
				value={filters?.sorter ?? 'datoForst'}
			>
				<option value="datoForst">Dato først</option>
				<option value="datoSist">Dato sist</option>
				<option value="arrangorForst">Arrangør (A-Å)</option>
				<option value="arrangorSist">Arrangør (Å-A)</option>
			</EventPageSelect>
		</form>
	);
};
